import { Account, AccountType as AccountTypeUtils, SystemAccount } from '@audibene/ta.utils-opportunity'

const AccountType = {
  ...AccountTypeUtils,
  /** Interation as part of migration */
  MIGRATION: 'MIGRATION',
} as const

type AccountType = typeof AccountType[keyof typeof AccountType]

enum System {
  ACCOUNT_SERVICE = 'ACCOUNT_SERVICE',
  APPOINTMENT_SERVICE = 'APPOINTMENT_SERVICE',
  DOCUMENT_SERVICE = 'DOCUMENT_SERVICE',
  OPPORTUNITY_SERVICE_JOB_CLOSE_ENDED_OPPORTUNITIES = 'OPPORTUNITY_SERVICE_JOB_CLOSE_ENDED_OPPORTUNITIES',
  PULSAR = 'PULSAR',
  SALESFORCE = 'SALESFORCE',
}

type MigrationAccount = Omit<SystemAccount, 'type'> & {
  type: typeof AccountType.MIGRATION
}

type IdentityAccount = Account | MigrationAccount

export { AccountType, System }
export type { IdentityAccount }
